import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'

const PrivateRoute = ({ component: Component }) => {
  const isAuth = useSelector(state => state.isAuth)

  /**
   * До авторизации закрыть внутренние роуты
   */
  return <Route>{isAuth ? <Component /> : <Redirect to='/login' />}</Route>
}

export default PrivateRoute
